import { z } from "zod";

export const microsoftOAuthCallbackSchema = z.object({
	id_token: z.string(),
});

export type MicrosoftOAuthCallbackPayload = z.infer<typeof microsoftOAuthCallbackSchema>;
